// typography.js

export const variants = {
	// 64px
	h1: {
		fontSize: '4rem',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 48px
	h2: {
		fontSize: '3rem',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 38px
	h3: {
		fontSize: '2.375rem',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 32px
	h4: {
		fontSize: '2rem',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 28px
	h5: {
		fontSize: '1.75rem',
		letterSpacing: '-0.02em',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 24px
	h6: {
		fontSize: '1.5rem',
		fontFamily: 'AmigaForever, Oxanium, sans-serif',
	},
	// 20px
	body1: {
		fontSize: '1.25rem',
		fontFamily: 'Oxanium',
	},
	// 18px
	subtitle1: {
		fontSize: '1.125rem',
		fontFamily: 'Oxanium',
	},
	// 16px
	subtitle2: {
		fontSize: '1rem',
		fontFamily: 'Oxanium',
	},
	// 16px
	body2: {
		fontSize: '1rem',
		fontFamily: 'Oxanium',
	},
	// 14px
	caption: {
		fontSize: '0.875rem',
		fontFamily: 'Oxanium',
	},
};

export const fontWeights = {
	regular: 400,
	medium: 600,
	bold: 700,
	heavy: 800,
};
